module.exports = require("@swa-ui/core/src/Area/Area.module.scss");